import { useNavigation } from '@actr/hooks';
import type { FooterProps } from '@actr/widgets/src/components/_misc/layouts/footer';
import { Footer as DefaultFooter } from '@actr/widgets/src/components/_misc/layouts/footer';
import { AkV2Routes } from '@actr/widgets/src/navigation/routes/ak-v2';
import type { FC } from 'react';
import React, { memo } from 'react';
import ProjectUtils from 'Root/utils/project';

const Footer: FC<FooterProps> = props => {
  const { isRoute } = useNavigation();

  const isVtbSearchFormPage = ProjectUtils.isVtb()
    && (
      isRoute(AkV2Routes.AVIA)
      || isRoute(AkV2Routes.HOTEL)
      || isRoute(AkV2Routes.HOTEL_SEARCH_VTB)
    );

  if (ProjectUtils.isSber() || isVtbSearchFormPage) {
    return null;
  }

  return (
    <DefaultFooter {...props} />
  );
};

export default memo(Footer);
